export const getActive = (state) => state.syncTransaction.active;
export const getInitiator = (state) => state.syncTransaction.initiator;
